export default __webpack_public_path__ + "static/media/review7.5ecc0fd4.jpg";